import type {
  Localization,
  LocaleUrlBuilder,
} from '~/composables/types/localizable'
import { EventListPageType } from '~/composables/types/strapiEventListPage'

export const buildMagazineLocaleUrl: LocaleUrlBuilder = (
  localization: Localization,
  targetLocale: string
): string | null => {
  if (!localization.slug) return null
  return `/${targetLocale.toLowerCase()}/magazine/${localization.slug}/`
}

export const buildEventListPageLocaleUrl: LocaleUrlBuilder = (
  localization: Localization,
  targetLocale: string
): string | null => {
  const localePrefix = targetLocale.toLowerCase()
  const pageType = localization.type

  switch (pageType) {
    case EventListPageType.CITY:
      return `/${localePrefix}/${localization.citySlug}/`

    case EventListPageType.CATEGORY:
      return `/${localePrefix}/c/${localization.categorySlug}/`

    case EventListPageType.CITY_CATEGORY:
      return `/${localePrefix}/${localization.citySlug}/${localization.categorySlug}/`

    case EventListPageType.TEAMEVENT: {
      const fullSlug = localization.slug || ''
      let citySlug = fullSlug

      if (citySlug.includes('_')) {
        citySlug = citySlug.split('_')[0]
      }
      if (citySlug.startsWith('teamevent-')) {
        citySlug = citySlug.substring('teamevent-'.length)
      } else if (citySlug.startsWith('teambuilding-')) {
        citySlug = citySlug.substring('teambuilding-'.length)
      }

      if (!citySlug) return null
      return `/${localePrefix}/teamevent/${citySlug}/`
    }

    case EventListPageType.GENERAL: {
      const fullSlug = localization.slug || ''
      const slug = fullSlug.split('_')[0] || fullSlug
      return `/${localePrefix}/t/${slug}/`
    }

    default:
      return null
  }
}
